import { isUndefined } from 'lodash';
import apiClient from '../../../core/Api';
import {
  ContentResponse,
  ContentQueryParams,
  Folder,
  Response,
  ContentRequestParams,
  SubCategoryType,
} from '../../../data/types/content.interface';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
class ContentsService {
  static createContent = (formData: FormData, type: string, videoType: string, config: any): Promise<ContentResponse> =>
    apiClient
      .post(`${API_BASE_URL}/video_recordings/${type}/${videoType}`, formData, config)
      .then((response) => response.data);

  static createFilesInBulk = (
    formData: FormData,
    type: string,
    videoType: string,
    config: any
  ): Promise<ContentResponse> =>
    apiClient
      .post(`${API_BASE_URL}/video_recordings/${type}/${videoType}/bulk`, formData, config)
      .then((response) => response.data);

  static createFolderContent = (params: ContentRequestParams): Promise<Folder[]> =>
    apiClient.post(`${API_BASE_URL}/contents/folder`, params).then((response) => {
      if (response.status === 304) {
        return Promise.reject({ message: 'Content with the same path already exists.', status: 304 });
      }
      return response.data;
    });

  static searchFolders = (searchText: string, fileType: string): Promise<Folder[]> =>
    apiClient
      .get(`${API_BASE_URL}/contents/folder`, { params: { q: searchText, fileType } })
      .then((response) => response.data);

  static getAllContents = async (params: ContentQueryParams): Promise<Response> =>
    apiClient.get(`${API_BASE_URL}/video_recordings/all`, { params }).then((response) => {
      const { data } = response;
      return data.videos;
    });

  static getFileList = async (type: string): Promise<ContentResponse[]> =>
    apiClient.get(`${API_BASE_URL}/video_recordings`, { params: { type } }).then((response) => {
      const { data } = response;
      return data;
    });

  static getDetails = async (id: number): Promise<ContentResponse> =>
    apiClient.get(`${API_BASE_URL}/video_recordings/${id}`).then((response) => {
      return response.data;
    });

  static fetchRealS3Content = async (url: string): Promise<{ url: string }> =>
    apiClient.get(`${url}`, { params: { contentUrl: url } }).then((response) => {
      return response.data;
    });

  static fetchRealDropboxContent = async (url: string): Promise<string> =>
    apiClient.get(`${API_BASE_URL}/video_recordings/link`, { params: { path: url } }).then((response) => {
      return response.data.url;
    });

  static updateContentDetails = async (
    id: number,
    type: string,
    params?: ContentRequestParams,
    formData?: FormData,
    config?: any
  ): Promise<ContentResponse | null> => {
    let response;
    console.log('....................................', type);

    if (type !== 'final' || isUndefined(config)) {
      console.log('111111111111111111111111111111111111');

      response = await apiClient.put(`${API_BASE_URL}/video_recordings/${id}`, { ...params, type });
    } else {
      console.log('22222222222222222222222222222');

      response = await apiClient.put(`${API_BASE_URL}/video_recordings/${id}`, formData, config);
    }
    return response ? response.data : null;
  };

  static bulkUpdate = async (ids: number[], params?: ContentRequestParams): Promise<string> => {
    const response = await apiClient.put(`${API_BASE_URL}/video_recordings/update`, {
      ...params,
      ids,
    });
    return response.data.status;
  };

  static removeContent = async (id: number, type: string): Promise<boolean> => {
    const response = await apiClient.delete(`${API_BASE_URL}/video_recordings/${id}`, {
      params: { type },
    });
    return response.status === 204;
  };

  static removeContentInBulk = async (ids: number[], type: string): Promise<boolean> => {
    const response = await apiClient.delete(`${API_BASE_URL}/video_recordings`, {
      params: { ids, type },
    });
    return response.status === 204;
  };

  static getFolderList = async (
    sourceType: string
  ): Promise<{
    mainFolders: Folder[];
    subFolders: Folder[];
    subCategories: SubCategoryType[];
  }> =>
    apiClient.get(`${API_BASE_URL}/folders/all`, { params: { sourceType } }).then((response) => {
      const { data } = response;
      return data;
    });

  static createCategory = async (name: string): Promise<SubCategoryType> =>
    apiClient.post(`${API_BASE_URL}/content-category`, { name }).then((response) => {
      const { data } = response;
      return data;
    });

  static createSubCategory = async (name: string, themeId: number): Promise<SubCategoryType> =>
    apiClient.post(`${API_BASE_URL}/sub-category`, { name, themeId }).then((response) => {
      const { data } = response;
      return data;
    });

  static getCategories = async (): Promise<SubCategoryType[]> =>
    apiClient.get(`${API_BASE_URL}/content-category`).then((response) => {
      return response.data;
    });

  static getSubCategories = async (): Promise<SubCategoryType[]> =>
    apiClient.get(`${API_BASE_URL}/sub-category`).then((response) => {
      return response.data;
    });

  static getAppliedFiltersCount = (listFilterParams: ContentQueryParams) => {
    const {
      folder,
      startDate,
      endDate,
      assetType,
      usedOrUnused,
      videoType,
      themes,
      topics,
      subTopics,
      publishStatus,
      authors,
      brands,
      events,
      identities,
      locations,
      persons,
    } = listFilterParams;
    const values = [
      folder,
      listFilterParams.category,
      listFilterParams.subCategory,
      startDate,
      endDate,
      assetType,
      usedOrUnused,
      videoType,
      themes,
      topics,
      subTopics,
      publishStatus,
      authors,
      brands,
      events,
      identities,
      locations,
      persons,
    ];
    return values.reduce((count, val: any) => {
      if (Array.isArray(val)) {
        return count + val.filter((v) => !!v?.toString().trim()).length;
      }
      if (typeof val === 'string') {
        return count + (val.trim() ? 1 : 0);
      }
      return val !== null && val !== undefined ? count + 1 : count;
    }, 0);
  };
}
export default ContentsService;
